// Swap the favicon to match the browser/OS color scheme. Chrome ignores the
// in-SVG prefers-color-scheme trick, so we switch the <link> href ourselves.
// The .ico fallback covers browsers without SVG favicon support.
const query = window.matchMedia('(prefers-color-scheme: dark)');

function applyFavicon(): void {
  // eslint-disable-next-line i18next/no-literal-string -- asset filename segment
  const scheme = query.matches ? 'dark' : 'light';
  const svg = document.getElementById('favicon') as HTMLLinkElement | null;
  const ico = document.getElementById('favicon-fallback') as HTMLLinkElement | null;
  if (svg) svg.href = `/favicon-${scheme}.svg`;
  if (ico) ico.href = `/favicon-${scheme}.ico`;
}

applyFavicon();
query.addEventListener('change', applyFavicon);
